package fr.frux.feature.map

import fr.frux.core.maps.Location

/**
 * Une fiche d'arbre vient de s'ouvrir : amener la carte dessus si elle n'y est pas deja.
 *
 * Un arbre du lot charge est a l'ecran ou tout pres (on l'a ouvert depuis son marqueur ou la
 * liste) : ne rien bouger. Sinon la fiche vient d'un lien, des favoris ou de l'activite, et la
 * carte affichee a cote en grand ecran resterait sur la derniere vue, loin de l'arbre.
 *
 * [MapViewModel.centerAndReload] recharge le lot autour de l'arbre : un deplacement programmatique
 * ne remonte pas par [MapViewModel.onCameraMoved]. Hors de la classe pour la meme raison que
 * [NearestDistanceLoader] : le ratchet LargeClass.
 */
fun MapViewModel.revealTree(
    treeId: Long,
    target: Location,
) {
    if (state.value.nearbyTrees.none { it.id == treeId }) centerAndReload(target)
}
